<template>
    <div class="container pt-3">
        <div class="row justify-content-lg-center">
            <div class="col-lg-12" style="font-size: 0.8rem">
                <div class="d-flex justify-content-between align-items-center" style="height: 37.79px; margin-bottom: 20px">
                    <div class="d-flex align-items-baseline" style="gap: 10px">
                        <h1 class="h1-title" style="font-weight: 500 !important; line-height: 21px">{{ $t('views.inventory.title') }}</h1>
                        <div v-if="currentMarket.sync_state && syncStates.findIndex((state) => state === 'FEE_REPORT_COMPLETED') > syncStates.findIndex((state) => state === currentMarket.sync_state) && currentMarket.status === 1" class="text-muted">
                            {{ $t('views.inventory.loadingText') }} <img src="@/assets/extension-loader.gif" height="24" />
                        </div>
                    </div>
                </div>
                <InventoryFilterCards v-model="isVisibleStoreCards" />
            </div>
        </div>
    </div>
    <div class="container action-header">
        <div class="d-flex justify-content-between align-items-center sm-flex-column">
            <div class="d-flex sm-flex-column">
                <div class="d-flex">
                    <div class="d-flex flex-column justify-content-center" style="border-right: 0.6px solid #e7eaf3; margin-right: 8px; padding-right: 15px; color: #677788">
                        <strong>{{ list.total }}</strong>
                        <span>{{ $t('views.inventory.result') }}</span>
                    </div>
                    <div class="mr-8">
                        <select :value="filterParams.perPage" class="form-select form-select-sm" @change="SET_FILTER_PARAMS({ key: 'perPage', value: +$event.target.value })">
                            <option v-for="i in [10, 25, 50, 100, 250]" :key="i" :value="i">{{ i }} {{ $t('views.inventory.perPage') }}</option>
                        </select>
                    </div>
                    <div class="mr-8">
                        <select :value="filterParams.page" class="form-select form-select-sm" @change="handlePage($event.target.value)">
                            <option v-for="n in totalPages" :key="n" :value="n" :selected="n === filterParams.page">{{ n }}. {{ $t('views.inventory.page') }}</option>
                        </select>
                    </div>
                </div>
                <div class="search-form">
                    <input
                        :value="filterParams.search"
                        class="form-control form-control-sm"
                        type="text"
                        :placeholder="$t('views.inventory.search')"
                        style="font-size: 13px; height: 37.5px"
                        @change="SET_FILTER_PARAMS({ key: 'search', value: $event.target.value.trim() })"
                        @keyup.enter="getInventoryList"
                    />
                    <button class="btn btn-sm btn-link" style="height: 37.5px; line-height: 1; position: absolute; top: -2px; right: 0" @click="getInventoryList">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
            <div class="d-flex">
                <button id="filterButton" class="btn btn-soft-primary btn-sm me-2" @click="toggleFilters" style="margin-right: 8px; border: 0.6px solid #e7eaf3">
                    <i class="fa fa-filter" style="font-size: 18px"></i>
                </button>
                <button class="btn bg-white btn-sm" @click="handleBulkCostModalOpen" style="margin-right: 8px; border: 0.6px solid #e7eaf3">
                    <i class="fa fa-dollar" style="font-size: 18px"></i>
                </button>
                <button class="btn bg-white btn-sm" @click="visibleAddProductModal = !visibleAddProductModal" style="margin-right: 8px; border: 0.6px solid #e7eaf3">
                    <i class="fa fa-plus" style="font-size: 18px"></i>
                </button>
                <button class="dropdown btn bg-white btn-sm" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" style="margin-right: 8px; border: 0.6px solid #e7eaf3">
                    <i class="fa fa-gear" style="font-size: 18px"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account" aria-labelledby="accountNavbarDropdown" data-popper-placement="top-end" style="width: 240px; padding: 0">
                    <label v-for="(column, index) in getColumns" :key="column.key" class="d-flex align-items-center" style="gap: 10px; height: 37px; padding-left: 10px; border-bottom: 0.6px solid #e7eaf3; color: #677788">
                        <input type="checkbox" class="form-check-input mt-0" :checked="column.visible" @change="setLocalStorageColumns(index)" />
                        {{ $t(`views.inventory.columns.${column.key}`) }}
                    </label>
                </div>
                <button class="dropdown btn btn-primary btn-sm" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="true" style="border: 0.6px solid #e7eaf3">
                    <span>{{ $t('views.inventory.takeAction') }}</span>
                    <span style="margin-left: 5px; padding: 3.67px 6.35px 3.67px 6.81px; border-radius: 5px; background-color: #f9fafc; color: #ffb53e; font-size: 10.5px; font-weight: 700; line-height: 12.71px; text-align: center">{{
                        selectedRows.length
                    }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account" aria-labelledby="accountNavbarDropdown" data-popper-placement="top-end" style="width: 240px; padding: 0">
                    <button class="action-header__btn btn" disabled>{{ $t('views.inventory.sendDepot') }}</button>
                    <button class="action-header__btn btn" :disabled="selectedRows.length === 0" @click="visibleDownloadLabelsModal = !visibleDownloadLabelsModal">
                        {{ $t('views.inventory.downloadTags') }}
                    </button>
                    <!-- <button class="action-header__btn btn">{{ $t('views.inventory.buy') }}</button> -->
                    <button class="action-header__btn btn" @click="removeProduct" :disabled="selectedRows.length === 0">{{ $t('views.inventory.removeProduct.label') }}</button>
                </div>
            </div>
        </div>
    </div>
    <InventoryFilters v-model="isFilterComponentVisible" @handleApply="handleApply" />
    <InventoryTableList v-model="hasColumnVisible" :bulk-cost-process="bulkCostProcess" @check-bulk-cost-process="handleCheckBulkCostProcess" @update-process-checked="handleUpdateProcessChecked" />
    <DownloadLabels v-model="visibleDownloadLabelsModal" />
    <AddProduct v-model="visibleAddProductModal" />
    <BulkCostModal v-model="showBulkCostModal" @save="handleBulkCostSave" @close="handleBulkCostModalClose" />
    <BulkCostErrorModal v-model="showBulkCostErrorModal" @handleDontShowAgain="handleBulkCostErrorDontShowAgain" />
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import InventoryFilters from '@/components/Inventory/InventoryFilters.vue'
import InventoryTableList from '@/components/Inventory/InventoryTableList.vue'
import DownloadLabels from '@/components/Inventory/modals/DownloadLabels.vue'
import AddProduct from '@/components/Inventory/modals/AddProduct.vue'
import InventoryFilterCards from '@/components/Inventory/InventoryFilterCards.vue'
import BulkCostModal from '@/components/Inventory/modals/BulkCostModal.vue'
import BulkCostErrorModal from '@/components/Inventory/modals/BulkCostErrorModal.vue'
import { modalManager } from '@/modal-manager.service'
import InventoryService from '@/services/inventory'

export default {
    name: 'Inventory',
    components: {
        InventoryFilters,
        InventoryFilterCards,
        InventoryTableList,
        DownloadLabels,
        AddProduct,
        BulkCostModal,
        BulkCostErrorModal,
    },
    data: function () {
        return {
            isVisibleStoreCards: true,
            isFilterComponentVisible: false,
            visibleDownloadLabelsModal: false,
            visibleAddProductModal: false,
            intervalId: null,
            isInputFocused: false,
            showBulkCostModal: false,
            bulkCostProcess: null,
            bulkCostProcessInterval: null,
            showBulkCostErrorModal: false,
            syncStates: [
                'INITIAL',
                'INVENTORY_SYNC_STARTED',
                'INVENTORY_SYNC_COMPLETED',
                'FEE_REPORT_COMPLETED',
                'RECENT_ORDERS_SYNC_STARTED',
                'RECENT_ORDERS_SYNC_COMPLETED',
                'HISTORICAL_ORDERS_SYNC_STARTED',
                'HISTORICAL_ORDERS_SYNC_COMPLETED',
                'SYNC_COMPLETED',
            ],
        }
    },
    computed: {
        ...mapState('inventory', ['columns', 'filterParams', 'list', 'selectedRows', 'isApplyFiltering', 'selectedFilterCard', 'filterOptions']),
        ...mapGetters({
            currentMarket: 'market/currentMarket',
            totalPages: 'inventory/totalPages',
        }),
        hasColumnVisible() {
            return this.columns.some((column) => column.visible)
        },
        getColumns() {
            return this.columns
        },
        bulkCostStatus() {
            if (!this.bulkCostProcess) return null
            return {
                isPending: this.bulkCostProcess.status === 'pending',
                isCompleted: this.bulkCostProcess.status === 'completed',
                hasErrors: this.bulkCostProcess.error_count > 0,
                tooltipText: this.bulkCostProcess.status === 'pending' ? this.$t('views.inventory.bulkCost.pendingTooltip', { count: this.bulkCostProcess.total_count }) : '',
            }
        },
    },
    created() {
        const columns = localStorage.getItem('columns.inventory')

        if (columns) {
            this.SET_COLUMNS(JSON.parse(columns))
        }
        this.getInventoryList()
        this.startBulkCostProcessCheck()
    },
    mounted() {
        if (this.$route.name === 'inventory') {
            document.querySelector('body').classList.add('is-inventory')
        }
        this.startCheckInterval()
        window.addEventListener('focusin', this.handleFocusIn)
        window.addEventListener('focusout', this.handleFocusOut)
    },
    unmounted() {
        document.querySelector('body').classList.remove('is-inventory')
        if (this.intervalId) clearInterval(this.intervalId)
        if (this.bulkCostProcessInterval) clearInterval(this.bulkCostProcessInterval)
        window.removeEventListener('focusin', this.handleFocusIn)
        window.removeEventListener('focusout', this.handleFocusOut)
    },
    methods: {
        ...mapActions('inventory', ['getInventoryList', 'downloadLabels', 'removeProducts', 'applyFilter', 'bulkCostCreate']),
        ...mapMutations('inventory', ['SET_COLUMN_TOGGLE', 'SET_FILTER_PARAMS', 'SET_LIST', 'SET_COLUMNS']),
        startCheckInterval() {
            this.intervalId = setInterval(() => {
                if (!this.isInputFocused) {
                    const allCalculatedZero = this.list.data.some((item) => !item.statuses.is_calculated)

                    if (allCalculatedZero && !this.isApplyFiltering) {
                        this.getInventoryList({ loading: false })
                    }
                }
            }, 2000)
        },
        handleApply(data) {
            this.SET_LIST(data)
        },
        handleFocusIn(event) {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                this.isInputFocused = true
            }
        },
        handleFocusOut(event) {
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                this.isInputFocused = false
            }
        },
        removeProduct() {
            if (confirm(this.$t('views.inventory.removeProduct.confirmText', { count: this.selectedRows.length, product: this.$tc('views.inventory.removeProduct.product', this.selectedRows.length) }))) {
                this.removeProducts({ ids: this.selectedRows })
            }
        },
        setLocalStorageColumns(index) {
            this.SET_COLUMN_TOGGLE(index)
            localStorage.setItem('columns.inventory', JSON.stringify(this.columns))
        },
        handlePage(page) {
            this.SET_FILTER_PARAMS({ key: 'page', value: +page })
            const { search, filter_id, sortBy, ...filterParams } = this.filterParams

            if (this.isApplyFiltering && !filter_id) {
                this.applyFilter({ payload: { filter_id: this.selectedFilterCard.id, options: this.filterOptions }, params: filterParams })
            } else {
                this.getInventoryList()
            }
        },
        toggleFilters() {
            this.isFilterComponentVisible = !this.isFilterComponentVisible
        },
        handleBulkCostModalOpen() {
            this.showBulkCostModal = true
            this.$nextTick(() => {
                modalManager.showModal('bulkCostModal')
            })
        },
        handleBulkCostModalClose() {
            modalManager.hideModal('bulkCostModal')
            this.showBulkCostModal = false
        },
        async handleBulkCostSave(formData) {
            try {
                this.$store.commit('set', { k: 'loading', v: { status: true, text: this.$t('views.inventory.modals.bulkCost.saving') } })

                const response = await this.bulkCostCreate(formData)
                if (response.success) {
                    this.$toast.success(this.$t('views.inventory.modals.bulkCost.success'))
                    this.handleBulkCostModalClose()

                    // Get process status after successful save
                    const processResponse = await InventoryService.getBulkCostProcess()
                    this.bulkCostProcess = processResponse.data

                    if (this.bulkCostProcess?.status === 'pending') {
                        this.bulkCostProcessInterval = setInterval(async () => {
                            const response = await InventoryService.getBulkCostProcess()
                            this.bulkCostProcess = response.data

                            if (this.bulkCostProcess.status === 'completed') {
                                clearInterval(this.bulkCostProcessInterval)
                                if (this.bulkCostProcess.error_count === 0) {
                                    await this.handleCompletedProcess(this.bulkCostProcess.id)
                                }
                            }
                        }, 5000)
                    }
                } else {
                    this.$toast.error(response.errors.map((error) => error.message).join(', '))
                }
            } catch (error) {
                console.error('Bulk cost update error:', error)
                this.$toast.error(this.$t('views.inventory.modals.bulkCost.error'))
            } finally {
                this.$store.commit('set', { k: 'loading', v: { status: false } })
            }
        },
        async startBulkCostProcessCheck() {
            try {
                const response = await InventoryService.getBulkCostProcess()
                this.bulkCostProcess = response.data

                if (this.bulkCostProcess) {
                    if (this.bulkCostProcess.status === 'completed') {
                        if (this.bulkCostProcess.error_count === 0) {
                            await this.handleCompletedProcess(this.bulkCostProcess.id)
                        }
                    } else if (this.bulkCostProcess.status === 'pending') {
                        this.bulkCostProcessInterval = setInterval(async () => {
                            const response = await InventoryService.getBulkCostProcess()
                            this.bulkCostProcess = response.data

                            if (this.bulkCostProcess.status === 'completed') {
                                clearInterval(this.bulkCostProcessInterval)
                                if (this.bulkCostProcess.error_count === 0) {
                                    await this.handleCompletedProcess(this.bulkCostProcess.id)
                                }
                            }
                        }, 5000)
                    }
                }
            } catch (error) {
                console.error('Error checking bulk cost process:', error)
            }
        },
        async handleCompletedProcess(processId) {
            try {
                await InventoryService.checkBulkCostProcess(processId)
                await this.getInventoryList()
                this.bulkCostProcess = null
            } catch (error) {
                console.error('Error handling completed process:', error)
            }
        },
        async handleCheckBulkCostProcess(processId) {
            await this.handleCompletedProcess(processId)
        },
        async handleBulkCostErrorDontShowAgain(processId) {
            try {
                await InventoryService.checkBulkCostProcess(processId)
                this.showBulkCostErrorModal = false
                this.bulkCostProcess = null
                await this.getInventoryList()
            } catch (error) {
                console.error('Error handling dont show again:', error)
            }
        },
        showBulkCostErrors() {
            if (this.bulkCostStatus?.isCompleted && this.bulkCostStatus?.hasErrors) {
                this.showBulkCostErrorModal = true
                modalManager.showModal('bulkCostErrorModal')
            }
        },
        handleUpdateProcessChecked(processId) {
            if (this.bulkCostProcess && this.bulkCostProcess.id === processId) {
                this.bulkCostProcess = {
                    ...this.bulkCostProcess,
                    is_checked: true,
                }
            }
        },
    },
    beforeUnmount() {
        modalManager.destroyModal('bulkCostModal')
        if (this.bulkCostProcessInterval) {
            clearInterval(this.bulkCostProcessInterval)
        }
    },
    watch: {
        'filterParams.perPage': function () {
            this.handlePage(1)
        },
        'filterParams.search': function () {
            this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
            this.getInventoryList()
        },
    },
}
</script>

<style lang="scss">
:root {
    --inventory-gray: #f8fafd;
    --inventory-primary: #ffb53e;
}
body.is-inventory {
    background-color: #fff !important;

    &.is-sticky {
        .action-header {
            position: sticky;
            top: 40px;
            z-index: 5;
            width: 100%;

            > div {
                border-top: 1px solid #e7eaf3b2;
                margin-top: 0;
            }
        }

        .custom-table-items {
            thead {
                box-shadow: 0px 60px 50px 0px #00203f40;
            }
        }
    }

    .action-header {
        & > div {
            display: block;
            background-color: var(--inventory-gray);
            margin-top: 10px;
            margin-bottom: 15px;
            font-size: 14px;
            font-weight: 400;
            line-height: 16.94px;
            padding-left: 12px;
            padding-right: 12px;
            height: 69.79px;
        }
        &__btn {
            display: flex;
            align-items: center;
            width: 100%;
            gap: 10px;
            height: 37px;
            padding-left: 10px;
            border-bottom: 0.6px solid #e7eaf3 !important;
            color: #677788 !important;

            &:active {
                border-color: transparent !important;
            }
        }
    }
}
.mr-8 {
    margin-right: 8px;
}
@media (width <= 767px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
    .modal-table,
    table {
        th,
        td {
            min-width: auto !important;
            padding: 0.5rem !important;

            button {
                padding: 0.5rem !important;
            }

            .text-ellipsis {
                &.title {
                    max-width: 175px !important;
                }
            }
        }
    }
    .sm-flex-column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start !important;
        align-items: baseline !important;
        gap: 0.5rem;

        & > div {
            border: 0 !important;
        }
    }
    body.is-inventory .action-header > div {
        height: auto !important;
    }
    .mr-8:last-child {
        margin-right: 0 !important;
    }
    .modal-dialog {
        min-width: auto !important;
    }
    .nav-segment {
        margin-right: 0 !important;
    }
    .close-button {
        position: absolute;
        top: 0;
        right: 0;

        i {
            color: #f8fafd !important;
            font-size: 1rem;
            background-color: #677788;
            padding: 5px;
            border-radius: 50%;
            line-height: 0;
        }
    }
    .modal-table {
        overflow-x: auto !important;
    }
    .sm-d-block {
        display: block !important;
    }
    .sm-max-w-100 {
        max-width: 100% !important;
    }
    .sm-align-items-start {
        align-items: flex-start !important;
    }
    #past-orders-tab {
        &::-webkit-scrollbar {
            display: none;
        }
        td {
            button {
                padding: 0 !important;
            }
        }
    }
}
@media (768px <= width <= 1024px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
}
</style>
